import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const SkuMappingSchema = z.object({
  sku: z.string(),
  values: z.array(z.string()),
});

const AdditionalAttributeKeysSchema = z.object({
  additionalAttributeKey1: z.string().nullish(),
  additionalAttributeKey2: z.string().nullish(),
  additionalAttributeKey3: z.string().nullish(),
  additionalAttributeKey4: z.string().nullish(),
  additionalAttributeKey5: z.string().nullish(),
  additionalAttributeKey6: z.string().nullish(),
  additionalAttributeKey7: z.string().nullish(),
  additionalAttributeKey8: z.string().nullish(),
  additionalAttributeKey9: z.string().nullish(),
  additionalAttributeKey10: z.string().nullish(),
});

export const getCin7CoreIntegration = {
  name: "getCin7CoreIntegration" as const,
  input: z.object({}),
  output: z.object({
    integration: z
      .object({
        id: zExt.objectId(),
        locationName: z.string().optional(),
        skuMappings: z.array(SkuMappingSchema).optional(),
        wmsEnabled: z.boolean(),
        omsEnabled: z.boolean(),
        saleAttributes: AdditionalAttributeKeysSchema.optional(),
        productAttributes: AdditionalAttributeKeysSchema.optional(),
      })
      .nullable(),
  }),
};
